module.exports = __webpack_public_path__ + "static/assets/7efc16240b399536e9f33961b23ebabd.png";